import {
    Navigate,
    Outlet,
} from "react-router-dom";
import routeConfig from "../configs/route.config";
import { Suspense } from "react";
import { Center, Spinner } from "@chakra-ui/react";

const PublicRoute = () => {
    const token = localStorage.getItem('access_token')
    if (token !== null) return <Navigate to={routeConfig.dashboard} />
    return (
        <Suspense
            fallback={
                <Center width='100%' height='100vh'>
                    <Spinner />
                </Center>
            }
        >
            <Outlet />
        </Suspense>
    )
};

export default PublicRoute;